// Validator is a HOC that takes any boolean-returning callback and an error object/string/number
// It returns an error of the specified type/shape if the callback returns false
export const Validator = (callback, error) => {
  return (value) => { return !callback(value) ? error : null; };
};

// isRequired is a really simple example of a potential Validator callback
export const isRequired = (value) => !!value;

// validateEmailFormat had been duplicated in a few places, so I gave it a new home here
export const validateEmailFormat = (em) => {
  if (em?.trim().length === 0) {
    // don't validate empty email in case it's not required
    return true;
  }
  const regexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regexp.test(em);
};

export const validateUrl = (url) => {
  if (url.trim().length === 0) {
    // don't validate empty url in case it's not required
    return true;
  }
  let urlToCheck = url;
  // if the URL doesn't begin with a protocol, add https://
  if (!url.match(/^[a-zA-Z]+:\/\//)) {
    urlToCheck = `https://${urlToCheck}`;
  }

  try {
    // eslint-disable-next-line no-new
    new URL(urlToCheck);
    return true;
  } catch (err) {
    return false;
  }
};
